import { useForm } from "react-hook-form";
import { useState } from "react";

import { useSnackbar } from "providers/SnackbarProvider";
import { useConfirmDialogExit } from "hooks";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import {
  buttonAdd,
  buttonAnnul,
  formAddSourceCode,
  labelAddCode,
  labelAddCodeSubtitle,
  snackbarResetChat,
  snackbarSummaryResetChatSubTitle,
  snackbarSummarySuccessAddSource,
  snackbarSummarySuccessAddSourceSubTitle,
} from "_constants";
import { addCodesProject, checkLastResetChat } from "services";
import { FormAddCode } from "components/form/FormAddCode";
import { resetLoadedStatus } from "store/slicer/GestioneDetailProjectSlice";
import { Button } from "primereact/button";
import { useAppDispatch } from "store/store";
import { FooterLeftAddCode } from "./components/FooterLeftAddCode";
import { setCheckInactiveAnswers } from "store/slicer/GestioneChatSlice";

export const ModalAddCode = ({
  modalVisibile = false,
  onClose,
  projectId,
}: {
  modalVisibile: boolean;
  onClose: Function;
  projectId: string;
}) => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(modalVisibile);
  const { showConfirmDialogExit } = useConfirmDialogExit();

  const { handleSubmit, control, setValue, watch } = useForm({
    defaultValues: {
      isArchive: false,
      projectId: projectId,
      sourceIdsList: [],
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  const sourceIdsList = watch("sourceIdsList");
  const { showSnackbar } = useSnackbar();

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    control._reset();
    setVisible(false);
    onClose();
  };

  const onSubmit = (formData: any) => {
    if (formData.sourceIdsList.length) {
      addCodesProject(formData)
        .then((_) => {
          checkLastResetChat(projectId).then((res) => {
            if (res.data.canShowWarning) {
              dispatch(setCheckInactiveAnswers(true));
              showSnackbar({
                severity: "warn",
                summary: snackbarResetChat,
                detail: snackbarSummaryResetChatSubTitle,
                life: 5000,
              });
            }
          }).catch((_) => { });
          showSnackbar({
            severity: "success",
            summary: snackbarSummarySuccessAddSource,
            detail: snackbarSummarySuccessAddSourceSubTitle,
            life: 5000,
          });
          dispatch(resetLoadedStatus());
          resetFormState();
        })
        .catch((_) => { });
    }
  };

  return (
    <SingleStepDialog
      onHideCallback={handleDismiss}
      height="648px"
      width="700px"
      header={
        <SingleStepHeaders
          title={labelAddCode}
          subtitle={labelAddCodeSubtitle}
        />
      }
      body={
        <SingleStepBody
          content={
            <form
              id={formAddSourceCode}
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit);
              }}
              className="width-100"
            >
              <FormAddCode
                setValue={setValue}
                watch={watch}
                projectId={projectId}
              />
            </form>
          }
        />
      }
      footer={
        <div className="flex-container justify-between align-center">
          <div>
            <FooterLeftAddCode sourceIdsList={sourceIdsList} />
          </div>
          <div>
            <Button
              label={buttonAnnul}
              onClick={handleDismiss}
              text
              severity="secondary"
            />
            <Button
              type="button"
              label={buttonAdd}
              onClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      }
      display={visible}
      setVisible={setVisible}
    />
  );
};
